import React from "react";
import AliceCarousel from "react-alice-carousel";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import PropColumn from "./PropColumn";
import CardSkeleton from "./CardSkeleton";
const responsive = {
  0: { items: 1 },
  600: { items: 1.5 },
  1024: { items: 2.2 },
  1400: { items: 3 },
  1800: { items: 3.5 },
};

const Carousel = ({ properties }) => {
  const safeProperties = Array.isArray(properties) ? properties : [];
  const items = [];
  safeProperties.forEach((property, index) => {
    items.push(
      <div key={index} className="px-3">
        <PropColumn property={property} />
      </div>,
    );
  });

  return (
    <div className="py-4 relative overflow-hidden min-h-[260px] frosted-carousel px-12">
      <AliceCarousel
        mouseTracking
        animationDuration={1000}
        paddingLeft={10}
        paddingRight={10}
        items={items}
        autoHeight={false}
        disableDotsControls={true}
        infinite={true}
        autoPlay={true}
        autoPlayInterval={10500}
        renderPrevButton={() => {
          return (
            <BsChevronLeft
              className="carousel-arrow hover:cursor-pointer transition-all absolute top-1/2 -translate-y-1/2 left-0 z-10 bg-white/80 rounded-full p-1 shadow-md"
              size={32}
            />
          );
        }}
        renderNextButton={() => {
          return (
            <BsChevronRight
              className="carousel-arrow hover:cursor-pointer transition-all absolute top-1/2 -translate-y-1/2 right-0 z-10 bg-white/80 rounded-full p-1 shadow-md"
              size={32}
            />
          );
        }}
        responsive={responsive}
        controlsStrategy="responsive"
      ></AliceCarousel>
    </div>
  );
};

export default Carousel;
